const carecentreTokens = {
  color: {
    primary: "#0765FF",
    primaryDeep: "#0349BD",
    primarySoft: "#DCE8FF",
    primaryFaint: "rgba(7, 101, 255, 0.055)",
    // terra/taupe retired — aliased to ink/neutral as a safety net
    terra: "#15191F",
    terraSoft: "#EFEEE9",
    taupe: "#797160",
    taupeSoft: "#ECEAE3",
    bg: "#F6F5F2",
    bgBone: "#EFEEE9",
    bgCard: "#FFFFFF",
    bgDark: "#15191F",
    textInk: "#15191F",
    textBody: "#3D434C",
    textMuted: "#797160",
    textQuiet: "#A8A092",
    line: "#E3E1DB",
    lineSoft: "#ECEAE3",
    lineStrong: "#CAC7BE",
    success: "#059669",
    warning: "#D97706",
    danger: "#DC2626",
    info: "#2563EB",
    successSoft: "#E8F5EC",
    warningSoft: "#FEF3E6",
    dangerSoft: "#FDECEA",
    infoSoft: "rgba(37, 99, 235, 0.1)",
    scoreHeaderBg: "#0349BD",
    scoreHeaderBgHover: "#0765FF",
    scoreHeaderText: "#FFFFFF",
    scoreHeaderMuted: "rgba(220, 232, 255, 0.78)",
    scoreHeaderPillBg: "rgba(220, 232, 255, 0.16)",
    scoreHeaderPillText: "#DCE8FF",
    scoreChipActiveBg: "#DCE8FF",
    scoreChipActiveBorder: "rgba(7, 101, 255, 0.22)",
  },
  font: {
    display:
      "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    body: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    italic: "'Fraunces', Georgia, 'Times New Roman', serif",
    mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
  },
  type: {
    displayLarge: { fontSize: "36px", lineHeight: "42px", fontWeight: 700 },
    display: { fontSize: "28px", lineHeight: "34px", fontWeight: 700 },
    pageTitle: { fontSize: "24px", lineHeight: "30px", fontWeight: 700 },
    section: { fontSize: "20px", lineHeight: "26px", fontWeight: 700 },
    subsection: { fontSize: "17px", lineHeight: "23px", fontWeight: 700 },
    cardTitle: { fontSize: "15px", lineHeight: "20px", fontWeight: 700 },
    bodyLarge: { fontSize: "16px", lineHeight: "24px", fontWeight: 400 },
    body: { fontSize: "14px", lineHeight: "21px", fontWeight: 400 },
    bodySmall: { fontSize: "13px", lineHeight: "19px", fontWeight: 400 },
    caption: { fontSize: "12px", lineHeight: "16px", fontWeight: 400 },
    label: { fontSize: "11px", lineHeight: "14px", fontWeight: 700 },
  },
  radius: {
    xs: "6px",
    sm: "10px",
    md: "14px",
    lg: "18px",
    xl: "24px",
    photo: "16px",
    full: "9999px",
  },
  space: {
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
    5: "20px",
    6: "24px",
    8: "32px",
    10: "40px",
    12: "48px",
  },
  shadow: {
    sm: "none",
    md: "0 16px 40px rgba(21, 25, 31, 0.1), 0 4px 14px rgba(21, 25, 31, 0.05)",
  },
};

export const carecentreStatus = {
  published: {
    label: "Published",
    color: carecentreTokens.color.success,
    background: "rgba(5, 150, 105, 0.12)",
  },
  completed: {
    label: "Completed",
    color: carecentreTokens.color.success,
    background: "rgba(5, 150, 105, 0.12)",
  },
  success: {
    label: "Success",
    color: carecentreTokens.color.success,
    background: "rgba(5, 150, 105, 0.12)",
  },
  healthy: {
    label: "Healthy",
    color: carecentreTokens.color.success,
    background: "rgba(5, 150, 105, 0.12)",
  },
  draft: {
    label: "Draft",
    color: carecentreTokens.color.warning,
    background: "rgba(217, 119, 6, 0.12)",
  },
  pending: {
    label: "Pending",
    color: carecentreTokens.color.warning,
    background: "rgba(217, 119, 6, 0.12)",
  },
  warning: {
    label: "Warning",
    color: carecentreTokens.color.warning,
    background: "rgba(217, 119, 6, 0.12)",
  },
  watch: {
    label: "Watch",
    color: carecentreTokens.color.warning,
    background: "rgba(217, 119, 6, 0.12)",
  },
  archived: {
    label: "Archived",
    color: carecentreTokens.color.danger,
    background: "rgba(220, 38, 38, 0.1)",
  },
  discontinued: {
    label: "Discontinued",
    color: carecentreTokens.color.danger,
    background: "rgba(220, 38, 38, 0.1)",
  },
  danger: {
    label: "Danger",
    color: carecentreTokens.color.danger,
    background: "rgba(220, 38, 38, 0.1)",
  },
  critical: {
    label: "Critical",
    color: carecentreTokens.color.danger,
    background: "rgba(220, 38, 38, 0.1)",
  },
  "in-progress": {
    label: "In progress",
    color: carecentreTokens.color.info,
    background: "rgba(37, 99, 235, 0.1)",
  },
  info: {
    label: "Info",
    color: carecentreTokens.color.info,
    background: "rgba(37, 99, 235, 0.1)",
  },
  active: {
    label: "Active",
    color: carecentreTokens.color.primary,
    background: carecentreTokens.color.primarySoft,
  },
  inactive: {
    label: "Inactive",
    color: carecentreTokens.color.textMuted,
    background: carecentreTokens.color.bgBone,
  },
  ai: {
    label: "AI",
    color: carecentreTokens.color.terra,
    background: carecentreTokens.color.terraSoft,
  },
  "ai-suggested": {
    label: "AI suggested",
    color: carecentreTokens.color.terra,
    background: carecentreTokens.color.terraSoft,
  },
  needs: {
    label: "Needs",
    color: carecentreTokens.color.textInk,
    background: carecentreTokens.color.bgBone,
  },
};

export const carecentreKloe = {
  safe: {
    label: "Safe",
    color: carecentreTokens.color.danger,
    background: "rgba(220, 38, 38, 0.1)",
  },
  effective: {
    label: "Effective",
    color: carecentreTokens.color.info,
    background: "rgba(37, 99, 235, 0.1)",
  },
  caring: {
    label: "Caring",
    color: "#6D28D9",
    background: "rgba(109, 40, 217, 0.1)",
  },
  responsive: {
    label: "Responsive",
    color: carecentreTokens.color.success,
    background: "rgba(5, 150, 105, 0.12)",
  },
  "well-led": {
    label: "Well-led",
    color: carecentreTokens.color.warning,
    background: "rgba(217, 119, 6, 0.12)",
  },
};

export default carecentreTokens;
